import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'
import { Event } from '../../engine/MetricsManager'

class Bloc extends Component {
    constructor(props) {
        super(props)
        this.handleClickBloc = this.handleClickBloc.bind(this)
    }

    handleClickBloc() {
        if (this.props.selectable) {
            if (this.props.gtm_id) {
                Event(this.props.gtm_id, 'me.click')
            }

            if (
                this.props.linked_data_id &&
                this.props.linked_data_value !== undefined
            ) {
                if (this.props.multi_select) {
                    store.dispatch({
                        type: 'SET_MULTI',
                        value: {
                            key: this.props.linked_data_id,
                            value: this.props.linked_data_value,
                        },
                    })
                } else {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: this.props.linked_data_id,
                            value: this.props.linked_data_value,
                        },
                    })
                }
            }
            if (
                this.props.linked_data_id &&
                this.props.linked_data_value_empty
            ) {
                if (this.props.multi_select) {
                    store.dispatch({
                        type: 'SET_MULTI',
                        value: {
                            key: this.props.linked_data_id,
                            value: undefined,
                        },
                    })
                } else {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: this.props.linked_data_id,
                            value: undefined,
                        },
                    })
                }
            }

            if (
                this.props.linked_data_id_2 &&
                this.props.linked_data_value_2 !== undefined
            ) {
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: this.props.linked_data_id_2,
                        value: this.props.linked_data_value_2,
                    },
                })
            }
            if (this.props.customMethod) {
                this.props.customMethod()
            }
            if (this.props.targetView) {
                history.push('/tunnelmobile/', {
                    targetView: this.props.targetView,
                })
            }
        }
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in pointer '
        const style = {}

        // width size, by default it's full width bloc.
        // allow to manage the number of bloc by row, and specify the position of the bloc to adapt marging.
        if (this.props.nbcolumn && this.props.nbcolumn !== undefined) {
            if (this.props.nbcolumn === 2) {
                if (this.props.gauche) {
                    className += ' bloc-gauche-2'
                }
                if (this.props.droit) {
                    className += ' bloc-droit-2'
                }
            } else if (this.props.nbcolumn === 3) {
                if (this.props.gauche) {
                    className += ' bloc-gauche-3'
                }
                if (this.props.milieu) {
                    className += ' bloc-milieu-3'
                }
                if (this.props.droit) {
                    className += ' bloc-droit-3'
                }
            } else if (this.props.nbcolumn === 4) {
                if (this.props.gauche) {
                    className += ' bloc-gauche-4'
                }
                if (this.props.milieu) {
                    className += ' bloc-milieu-4'
                }
                if (this.props.droit) {
                    className += ' bloc-droit-4'
                }
            } else {
                className += ' bloc-full'
            }
        }

        ///////////////////////////////////////////////
        // définition de l'état de selection du bloc //
        ///////////////////////////////////////////////
        var selected = false
        if (this.props.linked_data_id) {
            if (
                this.props.linked_data_value &&
                this.props.targetDataValue === this.props.linked_data_value
            ) {
                selected = true
            }
            if (
                this.props.multi_select &&
                Array.isArray(this.props.targetDataValue) &&
                this.props.targetDataValue.includes(
                    this.props.linked_data_value
                )
            ) {
                selected = true
            }
        }
        if (this.props.forceSelected) {
            selected = true
        }
        let content

        if (selected) {
            if (!this.props.no_visual_select) {
                if (this.props.alternative_select) {
                    className += ' selected-alt'
                } else {
                    className += ' selected'
                }
            }
            if (this.props.children) {
                content = <div className="Container">{this.props.children}</div>
            }
        } else {
            if (this.props.bgColor && this.props.bgColor !== undefined) {
                style.borderColor = this.props.bgColor
            }
        }

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle

        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        let premadeContent

        if (this.props.maturiteStyle) {
            style.display = 'inline-block'
            style.overflow = 'hidden'
            style.minHeight = '200px'
            premadeContent = (
                <div className="MaturiteChoiceStyle">
                    <img src="svg/oval.svg" className="oval" alt="oval_bg" />
                    <img
                        src={this.props.logourl}
                        className="logo"
                        alt={this.props.logourl}
                    />
                    <div className="strong-text bold-font margin10">
                        {this.props.text1}
                    </div>
                    <div className="light-text medium-font margin10">
                        {this.props.text2}
                    </div>
                </div>
            )
        } else if (this.props.imageTextStyle) {
            style.display = 'inline-block'
            style.overflow = 'hidden'
            style.minHeight = '165px'
            premadeContent = (
                <div>
                    <img src="svg/oval.svg" className="oval" alt="oval_bg" />
                    <img
                        src={this.props.logourl}
                        className="logo"
                        alt={this.props.logourl}
                    />
                    <div className="light-text medium-font margin5">
                        {this.props.text1}
                    </div>
                    <div className="strong-text bold-font margin5">
                        {this.props.text2}
                    </div>
                </div>
            )
        } else if (this.props.simpleImage) {
            premadeContent = (
                <img
                    src={this.props.simpleImage}
                    className="simpleImage"
                    alt={this.props.simpleImage}
                />
            )
            style.display = 'inline-block'
            style.overflow = 'hidden'
            style.minHeight = '106px'
        } else if (this.props.simpleWord) {
            premadeContent = (
                <div>
                    <div className="simpleWord">{this.props.text1}</div>
                </div>
            )
            style.display = 'inline-block'
            style.overflow = 'hidden'
            style.minHeight = '75px'
        } else if (this.props.simpleDoubleWord) {
            premadeContent = (
                <div>
                    <div className="simpleDoubleWord1 bold-font">
                        {this.props.text1}
                    </div>
                    <div className="simpleDoubleWord2">{this.props.text2}</div>
                </div>
            )
            style.display = 'inline-block'
            style.overflow = 'hidden'
            style.minHeight = '126x'
        }

        // height size, by default its 122px height
        if (this.props.height && this.props.height !== undefined) {
            style.height = this.props.height + 'px'
        }

        if (this.props.bgColor && this.props.bgColor !== undefined) {
            style.backgroundColor = this.props.bgColor
        }

        return (
            <div>
                <div
                    className={className}
                    style={style}
                    onClick={() => this.handleClickBloc()}
                >
                    {infobulle}
                    {premadeContent}
                </div>
                {content}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
    }
}

export default connect(mapStateToProps)(Bloc)
